/**
 * Convierte un valor a booleano el valor de un atributo HTML.
 *
 * Compatible con `true`, `false`, `undefined` y las cadenas `''`, `'on'`, `'true'` (true) y `off`, `'false'`. (false).
 *
 * Su mera presencia asume que es `true`.
 *
 * @since 0.1.25
 * @author Nelson Martell <nelson6e65@gmail.com>
 */
export function normalizeBooleanAttribute(value: string | boolean | undefined): boolean {
  let val: boolean;

  // Verificar conversiÃ³n al establecerlo desde markup
  if (typeof value === 'string') {
    const valueAsString = value.toLowerCase()
      .trim();

    val = valueAsString === '' || valueAsString === 'true' || valueAsString === 'on';
  } else {
    val = value === true || value === undefined;
  }

  return val;
}
